var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5370_541589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 80.002C62.5914 80.002 80.5 62.0933 80.5 40.002C80.5 17.9106 62.5914 0.00195312 40.5 0.00195312C18.4086 0.00195312 0.5 17.9106 0.5 40.002C0.5 62.0933 18.4086 80.002 40.5 80.002Z",
    fill: "#C8BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.0633 20.0175L57.9656 13.6797L23.8322 17.7819L26.53 20.6108L16.75 20.7664L19.95 37.9175L40.5989 59.393L29.3878 66.6708L42.13 79.9219C63.4589 79.0597 80.4989 61.5441 80.4989 40.0041C80.4989 38.6419 80.4278 37.2975 80.2944 35.9708L64.9433 20.0041L64.0633 20.0175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3872 57.7793H31.6094V64.446H49.3872V57.7793Z",
    fill: "#554D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6094 57.7793L49.3872 64.446V57.7793H31.6094Z",
    fill: "#686072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6089 64.4453H29.3867V66.6675H51.6089V64.4453Z",
    fill: "#474049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8307 58.8906H37.1641V63.3351H43.8307V58.8906Z",
    fill: "#ECEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6122 23.3353V28.2397C61.6122 34.1131 56.8344 38.8908 50.9611 38.8908H30.0411C24.1678 38.8908 19.39 34.1131 19.39 28.2397V23.3353H61.6122ZM64.9455 20.002H16.0566V28.2397C16.0566 35.9642 22.3166 42.2242 30.0411 42.2242H50.9611C58.6855 42.2242 64.9455 35.9642 64.9455 28.2397V20.002Z",
    fill: "#F79D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7237 47.7812H38.2793V54.4479H42.7237V47.7812Z",
    fill: "#EA8723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1671 17.7804H23.8338C23.2204 17.7804 22.7227 17.2826 22.7227 16.6693V14.447C22.7227 13.8337 23.2204 13.3359 23.8338 13.3359H57.1671C57.7804 13.3359 58.2782 13.8337 58.2782 14.447V16.6693C58.2782 17.2826 57.7804 17.7804 57.1671 17.7804Z",
    fill: "#F79D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9453 17.7812V31.1146C24.9453 38.5612 30.1809 44.7768 37.1675 46.3035V48.8924H43.8342V46.3035C50.8209 44.7768 56.0564 38.5612 56.0564 31.1146V17.7812H24.9453Z",
    fill: "#FAB816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9455 53.3359H36.0566V57.7804H44.9455V53.3359Z",
    fill: "#F79D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9453 17.7812V31.1146C24.9453 38.5612 30.1809 44.7768 37.1675 46.3035V48.8924H40.5009V17.7812H24.9453Z",
    fill: "#FFD259"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M56.0564 17.7812H24.9453V18.8924H56.0564V17.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.947 20.002H23.8359V23.3353H24.947V20.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7551 38.3193C26.244 38.1526 25.7529 37.9548 25.2773 37.7148C25.9751 39.306 26.9062 40.7682 28.0462 42.066C28.5796 42.1415 29.1196 42.1904 29.6707 42.206C28.5085 41.0726 27.5196 39.7704 26.7551 38.3193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1697 20.002H56.0586V23.3353H57.1697V20.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7293 37.7146C55.2537 37.9546 54.7626 38.1524 54.2515 38.319C53.487 39.7702 52.5004 41.0724 51.3359 42.2057C51.887 42.1902 52.4271 42.1413 52.9604 42.0657C54.1004 40.7679 55.0315 39.3079 55.7293 37.7146Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M42.7237 48.8906H38.2793V50.0017H42.7237V48.8906Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5370_541589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy_icon.4ded1e79598a527ba05e509b2ac3bae1.svg";
export { ForwardRef as ReactComponent };